<div *ngIf="loading" class="loader-overlay" >
  <div class="loader"></div>
</div>
<div *ngIf="uploadLoading" class="loader-overlay" >
  <div class="up-container">
    <div class="up-bg" *ngFor="let file of uploadingFiles">
      <div class="row" style="padding-top: 6px;">
        <div class="col-2"><img height="40px" src="assets/img/icons/dcm.png " alt=""></div>
        <div class="col-10">
          <div class="up-file"> {{file.name.length > 15 ? (file.name | slice:0:15) + '...' : file.name}} . アップロード中 <span style="margin-left: 25px;">{{ file.progress }}% </span></div>
        <progress id="file" [value]="file.progress" max="100"> {{ file.progress }}% </progress>
        </div>
        
      </div>
    </div>
  </div>
</div>
<div class="container-fluid px-4">
  <div class="card mt-4">

    <div class="card-header">
      <h1 style="font-size:22px">{{japaneseLabels['xRayRegistration']}}</h1>
      <p>レントゲン画像の申込みがありました。</p>

      <div class="card shadow-sm" style="background-color: #F6F6F6;">
        <div class="card-body">
          <table class="table">
            <tbody>
              <tr>
                <th style="width: 200px;">{{japaneseLabels['customerNameShow']}}</th>
                <td>{{customerData.first_name}} {{customerData.last_name}} ({{customerData.serial_no}})</td>
              </tr>
              <tr>
                <th style="width: 200px;">{{japaneseLabels['registerPhoneNumber']}}</th>
                <td>{{customerData.phone_number}}</td>
              </tr>
               <tr>
                <th style="width: 200px;">{{japaneseLabels['dateOfBirthShow']}}</th>
                <td>{{customerData.date_of_birth}}</td>
              </tr>
              <tr>
                <th style="width: 200px;">{{japaneseLabels['emailAddressShow']}}</th>
                <td>{{customerData.email_address}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Form starts here -->
      <form>
         <div class="mb-3">
          <p class="mt-3" style="font-size:14px">{{japaneseLabels['userWhoResisterXRay']}}</p>
          <select name="user" class="form-select" [(ngModel)]="profile_id" (change)="onUserChange($event)"> 
            <option value="">{{japaneseLabels['selectUser']}}</option>
            <option *ngFor=" let user of userList" [value]="user.profile_id">
              {{user.first_name}} {{user.last_name}}
            </option>
          </select>
           <!-- Error message -->
            <div *ngIf="userSelectError" class="text-danger mt-1" style="font-size:14px;">
              ユーザーを選択してください
            </div>
        </div>

        <div>
          <p class="mt-3" style="font-size:14px">{{japaneseLabels['hospitalName']}}</p>
          <input type="text" name="hospital_name" class="form-control border-bottom"[(ngModel)]="hospital_name" maxlength="50">          
        </div>
 
              

        <p class="card-header" style="font-size:14px">{{japaneseLabels['dcomFileUpload']}}</p>
        <div *ngIf="fileList.length < 5" class="card-body" >
        <div class="row" 
          [class.drag-over]="isDragOver"
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (dragenter)="onDragEnter($event)">
            <div class="col-md-6 text-center d-flex flex-column justify-content-center align-items-center drop-zone">
              <div>ここにドラッグアンドドロップ</div>
              <div>または</div>
              <div class="form-group">
                <label class="btn btn-outline-secondary upload-btn">
                  <i class="fa fa-file" aria-hidden="true"></i>
                  <input type="file" name="dicom_file" id="fileInput" hidden required (change)="upload($event)" multiple accept=".dcm"> {{japaneseLabels['selectFile']}}
                 
                </label>
              </div>
            </div>
        </div>
        </div>
        <div *ngIf="errorMessage" class="text-danger mt-2" style="font-size: 14px;">
          {{ errorMessage }}
        </div>
        <!-- Table Section (Show only if files uploaded) -->
        <div *ngIf="fileList.length > 0">
          <p class="card-header border-bottom py-2" style="font-size:14px">▼アップロードされたファイル</p>
          <div class="table-responsive text-nowrap">
            <table class="table" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>番号</th>
                  <th>ファイル名</th>
                  <th>ファイル形式</th>
                  <th>ファイル容量</th>
                  <th>アクション</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of fileList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ file.filename }}</td>
                  <td>{{ file.file_format || 'N/A' }}</td>
                  <td>{{ file.file_size_mb}}  </td>
                  <td>
                    <button class="btn btn-outline-danger" (click)="deleteFile(i)" [disabled]="loading">削除</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Message if no files -->
        <p *ngIf="fileList.length === 0" class="card-header border-bottom py-2" style="font-size:14px">
          ▼アップロードされたファイル
        </p>
  
        <p *ngIf="fileList.length === 0" class="card-header border-bottom py-2" style="font-size:14px">アップロードされていません</p>

        <!-- Buttons -->
        <div class="d-flex gap-3 p-3">
          <button type="button" class="btn btn-outline-info px-4" (click)="back()">戻る</button>        
          <button type="submit" [ngClass]="fileList.length > 0 ? 'btn btn-info' : 'btn custom-btn-color'" [disabled]="fileList.length === 0" (click)="goToDetails()">確認する</button>
           
        </div>
      </form>
      <!-- Form ends here -->

    </div>
  </div>
</div>
